var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/transfer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.9936406,12.0248856 C22.9897849,12.2537485 22.9142508,12.474646 22.758019,12.6529679 C22.6698264,12.7577304 22.5601677,12.8453489 22.4300358,12.9063447 L22.3301813,12.9464292 L3.57369782,21.9024178 C2.76269981,22.2896312 1.89228615,21.4937386 2.20555923,20.6514132 L5.4221456,11.9998531 L2.20555923,3.3485868 C1.89228615,2.50626145 2.76269981,1.71036877 3.57369782,2.09758222 L22.3437117,11.0582513 C22.5130608,11.1182416 22.652618,11.2209021 22.7584625,11.3489217 C22.9147429,11.5267954 22.989799,11.7469745 22.9940963,11.9678881 L22.9936406,12.0248856 Z M17.5788357,13 L7.18483573,13 L4.93983573,19.034 L17.5788357,13 Z M4.93983573,4.966 L7.18483573,11 L17.5788357,11 L4.93983573,4.966 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/transfer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.de840683107b3ef31092d9e697f9b229.svg";
export { ForwardRef as ReactComponent };